import React, { useState, useEffect } from 'react';
import ReactApexChart from "react-apexcharts";

const Timeline = ({ data }) => {
  const [chartOptions, setChartOptions] = useState({});
  const [chartSeries, setChartSeries] = useState([]);

  useEffect(() => {
    if (!data || data.length === 0) return;

    const formattedData = data.map(item => {
      const [year, month] = item.month.split("-").map(Number);
      const timestamp = new Date(year, month - 1, 1).getTime();
      return { x: timestamp, y: item.total };
    });

    const timestamps = formattedData.map(item => item.x);
    const minDate = Math.min(...timestamps);
    const maxDate = Math.max(...timestamps);

    setChartOptions({
      chart: {
        type: 'area',
        height: 288,
        toolbar: { show: false },
        zoom: { enabled: false },
      },
      colors: ['#6435c9'],
      dataLabels: { enabled: false },
      markers: { size: 0, style: 'hollow' },
      xaxis: {
        type: 'datetime',
        tickAmount: data.length,
        min: minDate,
        max: maxDate,
        labels: {
          formatter: (value) => {
            const date = new Date(value);
            return date.toLocaleString('en-US', {
              month: 'short',
              year: 'numeric',
            }); // e.g., "Feb 2025"
          }
        }
      },
      tooltip: {
        x: {
          format: 'MMM yyyy'
        }
      },
      fill: {
        type: 'gradient',
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.7,
          opacityTo: 0.9,
          stops: [0, 100]
        }
      },
      stroke: {
        show: true,
        curve: 'smooth',
        width: 2,
      },
      grid: {
        yaxis: { lines: { show: false } }
      },
    });

    setChartSeries([{
      name: "Total",
      data: formattedData
    }]);
  }, [data]);

  if (!data || data.length === 0) return null;

  return (
    <div>
      <ReactApexChart
        options={chartOptions}
        series={chartSeries}
        type="area"
        height="300px"
      />
    </div>
  );
};

export default Timeline;


// import React, { Component } from 'react';
// import ReactApexChart from "react-apexcharts";

// class Timeline extends Component {
//     constructor(props) {
//         super(props);

//         this.state = {
//             options: {
//                 chart: {
//                     type: 'area',
//                     height: 288,
//                     toolbar: { show: false },
//                     zoom: { enabled: false },
//                 },
//                 colors: ['#6435c9'],
//                 dataLabels: { enabled: false },
//                 markers: { size: 0, style: 'hollow' },
//                 xaxis: {
//                     type: 'datetime',
//                     tickAmount: 6,
//                 },
//                 tooltip: {
//                     x: { format: 'MMM yyyy' }
//                 },
//                 fill: {
//                     type: 'gradient',
//                     gradient: {
//                         shadeIntensity: 1,
//                         opacityFrom: 0.7,
//                         opacityTo: 0.9,
//                         stops: [0, 100]
//                     }
//                 },
//                 stroke: {
//                     show: true,
//                     curve: 'smooth',
//                     width: 2,
//                 },
//                 grid: {
//                     yaxis: { lines: { show: false } }
//                 },
//             },
//             series: [{
//                 name: "Total",
//                 data: this.formatData(props.data),
//             }],
//         };
//     }

//     // Function to format the data from props
//     formatData(data) {
//         return data.map(item => {
//             const [year, month] = item.month.split("-").map(Number);
//             const timestamp = new Date(year, month - 1, 1).getTime(); // First day of the month
//             return [timestamp, item.total];
//         });
//     }

//     render() {
//         return (
//             <div>
//                 <ReactApexChart
//                     options={this.state.options}
//                     series={this.state.series}
//                     type="area"
//                     height="300px"
//                 />
//             </div>
//         );
//     }
// }

// export default Timeline;
